// extracted by mini-css-extract-plugin
module.exports = {"tableIcons":"entityFollows_tableIcons__2IrHA","disbled":"entityFollows_disbled__17V2R"};